export const userCenterSidebar = {
    tbd: '项目详情开发中',
    organization: '组织架构',
    setting: '设置',
    accountSetting: '账号设置',
    logoSetting: 'logo设置',
    enterpriseInformation: '企业信息',
    templateSetting: '模板设置',
    inspirationList: 'AI灵感',
    customWholeHouseDesign: '全屋定制',
    decorationCompany: '装修公司',
    finishedFurniture: '成品家具',
    aluminumDoorsAndWindows: '铝门窗',
    realEstateProperty: '房产/物业',
    other: '其他',
    verified: '已认证',
    enterpriseAuthentication: '企业认证',
    enterpriseName: '企业名称',
    industryType: '所属行业',
    enterpriseScale: '企业规模',
    enterpriseAddress: '企业地址',
    contactPerson: '联系人',
    mobile: '手机号',
    email: '邮箱',
    saveSuccess: '保存成功',
    lessThan10: '10人以下',
    from10To20: '10~20人',
    from20To50: '20~50人',
    from50To100: '50~100人',
    from100To500: '100~500人',
    from500To1000: '500~1000人',
    moreThan1000: '1000人以上',
    administrator: '管理员',
    dataDashboard: '数据看板',
    enterpriseMaterial: '企业素材',
    personalMaterial: '个人素材',
    message: '消息',
    branchOffice: '分公司',
    enterpriseDecoration: '企业方案',
};
